module.exports = __webpack_public_path__ + "static/media/joshua-tree.a6339e26.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/joshua-tree.png
 ** module id = 186
 ** module chunks = 0
 **/